import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

/**
 * Core actions for space warning features.
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * Load warnings for the current space entity and scenario context.
     */
    loadForCurrentEntity: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
      reducers: {
        request: () => ({
          ...State.INITIAL,
          isLoading: true,
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          error,
          isLoading: false,
        }),
        cancellation: ({ state }) => ({
          ...state,
          isLoading: false,
        }),
      },
    }),
    /**
     * Load warnings for the supplied space entity and scenario context.
     */
    load: store.actions.request({
      input: store.actions.Data.asIs<{
        context: ents.core.admin.Context.ForScenario
        entityId: ec.models.EntityId
      }>(),
      output: store.actions.Data.asIs<readonly ents.extra.space.Warning[]>(),
      reducers: {
        request: ({ state }) => ({
          ...state,
          isLoading: true,
        }),
        success: ({ state, data: { response } }) => ({
          ...state,
          error: undefined,
          isLoading: false,
          lookup: Object.fromEntries(response.map(w => [w.code, w.message])),
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          error,
          isLoading: false,
        }),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
